import { useEffect, useState } from 'react'
import { Box, Paper } from '@material-ui/core'
import FilledButton from '../FilledButton'
import DownloadForm from '../DownloadForm'
import { useStyles } from './styles'
const PDFViewer = (props) => {
  const {
    amendment_form_presigned_url,
    agreement_form_presigned_url,
    tandc_form_presigned_url,
    approval_form_presigned_url,
  } = props
  const classes = useStyles()
  const [edrp, setEDRP] = useState(false)
  const [tandc, setTandC] = useState(false)
  const [sdp, setSDP] = useState(false)
  const [pto, setPTO] = useState(true)
  const toolbar = '#toolbar=0'
  const [PDFViewLink, setPDFViewLink] = useState(``)
  useEffect(() => {
    approval_form_presigned_url &&
      setPDFViewLink(`${approval_form_presigned_url}`)
    if (!approval_form_presigned_url) {
      setEDRP(true); setPDFViewLink(`${amendment_form_presigned_url}`)
    } else {
      setEDRP(false)
    }
    setTandC(false)
    setSDP(false)
    setPTO(true)
  }, [approval_form_presigned_url, amendment_form_presigned_url])
  return (
    <div className={classes.layout}>
      <Box className={classes.pdftab}>
        {' '}
        {approval_form_presigned_url && (
          <FilledButton
            label="Application Summary"
            primary={false}
            pdftab={true}
            pdftabselected={pto ? true : false}
            onClick={() => {
              setEDRP(false)
              setSDP(false)
              setTandC(false)
              setPTO(true)
              setPDFViewLink(`${approval_form_presigned_url}`)
            }}
            width="150px"
          ></FilledButton>
        )}
        {tandc_form_presigned_url && (<FilledButton
          label="Program T&C Document"
          primary={false}
          pdftab={true}
          pdftabselected={tandc ? true : false}
          onClick={() => {
            setEDRP(false)
            setSDP(false)
            setTandC(true)
            setPTO(false)
            setPDFViewLink(`${tandc_form_presigned_url}`)
          }}
          width="160px"
        ></FilledButton>
        )}
        {amendment_form_presigned_url && (<FilledButton
          label="EDRP Amendment"
          primary={false}
          pdftab={true}
          pdftabselected={edrp ? true : false}
          onClick={() => {
            setEDRP(true)
            setSDP(false)
            setTandC(false)
            setPTO(false)
            setPDFViewLink(`${amendment_form_presigned_url}`)
          }}
          width="135px"
        ></FilledButton>
        )}
        {agreement_form_presigned_url && (<FilledButton
          label="SDP Agreement"
          primary={false}
          pdftab={true}
          pdftabselected={sdp ? true : false}
          onClick={() => {
            setEDRP(false)
            setSDP(true)
            setTandC(false)
            setPTO(false)
            setPDFViewLink(`${agreement_form_presigned_url}`)
          }}
          width="120px"
        ></FilledButton>
        )}
      </Box>
      <Paper elevation="2" className={classes.pdf}>
        <iframe
          title="test"
          src={`${PDFViewLink}${toolbar}`}
          width="100%"
          height="100%"
          margin="0 0"
          frameBorder="0"
        />
      </Paper>
      <Box className={classes.download}>
        <DownloadForm PDFViewLink={PDFViewLink}></DownloadForm>
      </Box>
    </div>
  )
}
export default PDFViewer
